import { SxProp, View } from 'dripsy';

interface TableViewCellProps {
  flex?: number;
  width?: number;
  align?: 'left' | 'right' | 'center';
  sx?: SxProp;
}

export const TableViewCell: React.FC<TableViewCellProps> = ({ children, flex = undefined, width = undefined, align, sx }) => {
  const alignItems = align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start';
  return <View sx={{ flex: !!width ? undefined : 1, width: !!flex ? undefined : width, alignItems, ...sx }}>{children}</View>;
};
